// React Query keys for the Grill kitchen board (under ['shop', id] so shop-wide invalidation reaches them).
export const grillKeys = {
  kitchen: (shopId: string) => ['shop', shopId, 'grill', 'kitchen'] as const,
  menu: (shopId: string) => ['shop', shopId, 'grill', 'menu'] as const,
};
